import axios from "axios";
import { writeActiveThemeCache, writeThemeRecord } from "../themes/themeCache";

let pending = null;
let pendingKey = null;

function sameVisit(theme, preview) {
  if (!theme || !theme.theme_key || !theme.settings) return false;
  if (preview) return Boolean(theme.is_preview) && theme.theme_key === preview;
  return !theme.is_preview;
}

function primedTheme(preview) {
  if (typeof window === "undefined") return null;
  const theme = window.__ECOM_ACTIVE_THEME__;
  return sameVisit(theme, preview) ? theme : null;
}

function remember(theme, preview) {
  if (!sameVisit(theme, preview)) return;
  if (preview) writeThemeRecord(theme);
  else writeActiveThemeCache(theme);
  if (typeof window !== "undefined") window.__ECOM_ACTIVE_THEME__ = theme;
}

function fetchTheme(preview) {
  const key = preview || "";
  const endpoint = preview
    ? `/api/active-theme?preview_theme=${encodeURIComponent(preview)}`
    : "/api/active-theme";
  pendingKey = key;
  pending = axios
    .get(endpoint)
    .then((res) => {
      const theme = res.data && res.data.active_theme;
      if (sameVisit(theme, preview)) {
        remember(theme, preview);
        return theme;
      }
      return primedTheme(preview);
    })
    .catch(() => primedTheme(preview))
    .finally(() => {
      pending = null;
      pendingKey = null;
    });
  return pending;
}

export function loadActiveTheme(previewKey) {
  const preview = previewKey || "";
  const ready = primedTheme(preview);
  if (ready) return Promise.resolve(ready);
  if (pending && pendingKey === preview) return pending;

  if (
    typeof window !== "undefined" &&
    window.__ECOM_THEME_PROMISE__ &&
    (window.__ECOM_THEME_PROMISE_KEY__ || "") === preview
  ) {
    pendingKey = preview;
    pending = Promise.resolve(window.__ECOM_THEME_PROMISE__)
      .then((theme) => {
        if (sameVisit(theme, preview)) {
          remember(theme, preview);
          return theme;
        }
        pending = null;
        pendingKey = null;
        return fetchTheme(preview);
      })
      .finally(() => {
        pending = null;
        pendingKey = null;
      });
    return pending;
  }

  return fetchTheme(preview);
}
